<template>

    <div v-if="active" class="page-loader">

        <div class="loader"></div>

    </div>

</template>

<script>

export default {

    name: 'page-loader',

    data: () => {

        return {

            active: false

        }
    },

    methods: {

        start() {
            this.active = true
        },

        stop() {
            this.active = false
        }
    }

}

</script>

<style lang="scss" scoped>

.page-loader {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
}

</style>
